// src/components/results/PulseScanResultRow.jsx
import React, { memo } from "react";
import Spacer from "../../Spacer";
import { useTranslation } from "react-i18next";
import { isPassingHrSignalQuality } from "../views/quality";
import { formatValidatedMeasurement } from "../../../utils/results/validatedRanges";

/**
 * PulseScanResultRow
 * ------------------
 * One row in the results list.
 *
 * Props:
 * - time: string (e.g. "13:28")
 * - date: string (e.g. "12.01.26")
 * - hr: number | string (e.g. 72)
 * - unit?: string (default "bpm")
 * - onClick?: () => void
 */
export default memo(function PulseScanResultRow({
  time,
  date,
  hr,
  hrQuality,
  unit = "bpm",
  onClick,
}) {
  const { t } = useTranslation();

  const hrIsBad = hrQuality != null && !isPassingHrSignalQuality(hrQuality);

  return (
    <div className="w-full flex flex-col">
      <button
        type="button"
        onClick={onClick}
        className={[
          "w-full text-left py-2 flex flex-col gap-2 bg-transparent",
          onClick ? "cursor-pointer" : "cursor-default",
        ].join(" ")}
        disabled={!onClick}
      >
        <div className="w-full flex items-center gap-4">
          <div className="shrink-0 w-fit flex flex-col items-center justify-center leading-tight">
            <div>{time}</div>
            <div className="muted-text">{date}</div>
          </div>

          <div className="flex-1 grid grid-cols-[1fr] items-center">
            <div className="flex flex-col items-center justify-center">
              <p>{t("result.pulse.hrLabel", "Heart Rate")}</p>
              <div
                className={[
                  "title-text",
                  hrIsBad ? "text-greyscale-3" : "text-primary",
                ].join(" ")}
              >
                {formatValidatedMeasurement("hr", hr)}
                <span className="muted-text">
                  {" "}
                  {t("result.pulse.unit", unit)}
                </span>
              </div>
            </div>
          </div>
        </div>

        {hrIsBad ? (
          <div className="w-full text-center">
            <p className="muted-text">
              {t("result.pulse.qualityFailTitle", "Low HR signal quality.")}{" "}
              {t("result.pulse.qualityFailSubtitle", "Please try again.")}
            </p>
          </div>
        ) : null}
      </button>

      <Spacer />
    </div>
  );
});
